module.exports = __webpack_public_path__ + "static/media/explore_02.a1c4e92b.jpg";